import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FlagValidacionActivaFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='&nbsp;' htmlFor='checkbox-flagValidacionActiva' md={12} />
      <Col md={12}>
        <Field name='flagValidacionActiva'>
          {({ field }) => (
            <Form.Checkbox
              {...field}
              checked={iValue}
              disabled={fIsSubmitting}
              id='checkbox-flagValidacionActiva'
              label='Validación activa'
            />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagValidacionActivaFormGroup)
